// extracted by mini-css-extract-plugin
export default {"img":"RoundFlagItem_img__acDvH"};